<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">别名</span>
        <el-input v-model="parameter.alias" />
      </div>
      <div class="item">
        <span class="item_title">素材师</span>
        <el-input v-model="parameter.material_engineer_name" />
      </div>
      <div class="item">
        <span class="item_titles">最近10天最高成本区间</span>
        <el-select
          v-model="parameter.max_cost_last_ten"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item,index) in groupList"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <!-- <el-button style="height:37px" type="primary" icon="el-icon-bottom" @click="reportExport">导出报表</el-button> -->
    </div>
    <!-- <div class="content1">
      <div>
        合计
      </div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.total_consume ? tableData.total_data.total_consume : 0 }}</div>
      </div>
    </div> -->
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column
          prop="alias"
          label="别名"
        />
        <el-table-column
          prop="cost"
          label="成本"
        />
        <el-table-column
          prop="cost_date"
          label="日期"
        />
        <el-table-column
          prop="max_cost_last_10_day"
          label="最近10天最高成本"
          sortable
        />
        <el-table-column
          prop="max_cost_last_10_date"
          label="最近10天最高成本日期"
        />
      </el-table>
      <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
// import { video_material_cost } from '@/api/materialReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import ExpandClose from '@/components/ExpandClose/index.vue'
import { getData } from '@/api/adDetail.js'
export default {
  components: {
    PaginationRight
    // ExpandClose
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        alias: null,
        material_engineer_name: null,
        max_cost_last_ten: null,
        name: null,
        material_id: null,
        account_id: null,
        summary_type: '1'
      },
      group_name: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      activeItem: null,
      activeText: null,
      order_by: {}, // 表格数据排序
      groupList: [
        {
          label: '3万',
          value: '30000'
        },
        {
          label: '5万',
          value: '50000'
        },
        {
          label: '10万',
          value: '100000'
        },
        {
          label: '20万',
          value: '200000'
        },
        {
          label: '50万',
          value: '500000'
        },
        {
          label: '100万',
          value: '1000000'
        }
      ]
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    searchclick() {
      this.parameter.page = 1
      this.getDataList()
    },
    async getDataList() {
      const data = await getData({
        page: this.parameter.page,
        page_size: this.parameter.pageSize,
        alias: this.parameter.alias,
        material_engineer_name: this.parameter.material_engineer_name,
        max_cost_last_ten: this.parameter.max_cost_last_ten,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      console.log('数据=====', data)
      this.tableData = data.data
      this.loading = false
    },
    // 获取数据列表
    // async getDataList() {
    //   this.loading = true
    //   // // value为ture,从搜索按钮点击进入方法，清空排序
    //   // value && this.sortOrderChang()
    //   const data = await video_material_cost({ ...this.parameter,
    //     begin_time: this.date && this.date.length ? this.date[0] : null,
    //     end_time: this.date && this.date.length ? this.date[1] : null,
    //     order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
    //   })
    //   this.tableData = data.data
    //   this.loading = false
    // },
    // // 投放组选搜索
    // async querySearchAsync(queryString, cb) {
    //   const data = await listMaterial_bind_groups({
    //     name: queryString || null
    //   })
    //   cb(data.data.list.map((item) => {
    //     return {
    //       value: item.group_name,
    //       address: item.id
    //     }
    //   }))
    // },
    // 选中哪一项
    handleSelect(item) {
      this.group_name = item.value
      this.parameter.group_id = item.address
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 清空排序
    // sortOrderChang() {
    //   this.order_by = {}
    //   this.$refs.tableRef.clearSort()
    // },
    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : 'max_cost_last_10_day'
      this.getDataList()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        name: null,
        material_id: null,
        account_id: null,
        summary_type: '1'
      }
      this.group_name = null
      this.date = []
      this.order_by = {}
      this.$refs.tableRef.clearSort()
      this.getDataList()
    },
    // async blur1() {
    //   if (this.activeItem.consume !== this.activeText) {
    //     try {
    //       await set_cost({ id: this.activeItem.id, cost: this.activeText })
    //       this.$message({
    //         message: '修改消耗成功',
    //         type: 'success'
    //       })
    //       this.getDataList()
    //     } catch (err) {
    //       this.activeItem = null
    //       this.activeText = null
    //     }
    //   }
    //   this.activeItem = null
    //   this.activeText = null
    // },

    // 导出报表
    // async reportExport() {
    //   await export_report({ ...this.parameter,
    //     begin_time: this.date && this.date.length ? this.date[0] : null,
    //     end_time: this.date && this.date.length ? this.date[1] : null
    //   })
    //   this.$message({
    //     message: '已在后台中导出',
    //     type: 'success'
    //   })
    // },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }

  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 55px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  // align-items: flex-end;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      width: 60px;
       display: inline-block;
    }
    .item_titles{
      width: 156px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>

